/**
 * Formats a valid card expiry stringed number to our
 * desired spaced slash format
 *
 * @param value "0627"
 * @returns "06 / 27"
 */
export function formatCompactExpiry(value: string) {
  const month = value.slice(0, value.length - 2);
  const year = value.slice(value.length - 2);

  return `${month} / ${year}`;
}

/**
 * Formats a valid card expiry string that already contains slashes
 * to our desired spaced slash format
 *
 * @param value "06/27"
 * @returns "06 / 27"
 */
export function formatSlashedExpiry(value: string) {
  // Enforce double digit format
  let [month, year] = value.split("/");
  if (month.trim().length === 1) {
    month = `0${month.trim()}`;
  }
  year = `${year.trim()}`;

  return `${month} / ${year}`;
}

/**
 * Formats a valid card expiry string that already contains
 * a form of MM entered ("6 / " or "06 / ") to enforce
 * a double digit format on the month.
 *
 * @param value "6 / " or "06 / "
 * @returns "06 / "
 */
export function formatSpacedExpiry(value: string) {
  let [month, year] = value.split(" / ");
  // Enforce double digit format
  if (month.trim().length === 1) {
    month = `0${month.trim()}`;
  }
  year = `${year.trim()}`;

  return `${month} / ${year}`;
}

/**
 * Formats a valid card expiry string that contains MM and inserts a slash
 *
 * @param value "6 / " or "06 / "
 * @returns "06"
 */
export function prepExpiryForYearInput(value: string) {
  return `${value.slice(0, 2)} / ${value.slice(2)}`;
}

/**
 * Formats a card expiry string that already contains
 * a form of MM entered ("6 / " or "06 / ") and removes the spaced
 * slashes.
 *
 * Intended to be used alongside `onChange` or `input` event listeners, where
 * the input is actively being formatted on <input /> value changes. This function
 * would be used to handle character deletion to funnel the user to the "month" input.
 *
 * @param value "6 / " or "06 / "
 * @returns "06"
 */
export function prepExpiryForMonthInput(value: string) {
  return value.substring(0, 2);
}
